import { render, staticRenderFns } from "./RecoverPassword.vue?vue&type=template&id=52f53f79&scoped=true&"
import script from "./RecoverPassword.vue?vue&type=script&lang=js&"
export * from "./RecoverPassword.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPassword.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RecoverPassword.vue?vue&type=style&index=1&id=52f53f79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f53f79",
  null
  
)

export default component.exports